export enum eDocumentType {
  Standard = 'standard',
  Portal = 'portal',
}
